import * as Sentry from "@sentry/react";
import posthog from "posthog-js";
import { useEffect } from "react";
import { useAuth } from "@/providers/auth-provider";

export function SentryUserContext() {
  const { user } = useAuth();

  useEffect(() => {
    if (user) {
      // Get PostHog session ID
      const sessionId = posthog.get_session_id();

      Sentry.setUser({
        id: user.id,
        email: user.email,
        username: `${user.firstName} ${user.lastName}`,
      });

      // Set PostHog session ID as a tag for easy filtering
      Sentry.setTag("posthog_session_id", sessionId);

      // Also set as context for more detail
      Sentry.setContext("posthog", {
        session_id: sessionId,
        session_url: `${import.meta.env.VITE_POSTHOG_HOST}/project/${import.meta.env.VITE_POSTHOG_PROJECT_ID}/replay/${sessionId}`,
      });
    } else {
      Sentry.setUser(null);
      Sentry.setTag("posthog_session_id", null);
      Sentry.setContext("posthog", null);
    }
  }, [user]);

  return null;
}
